import { createModalSelectors } from '@core/modal/model/selectors';
import { createModalSlice } from '@core/modal/model/slice';
/**
 *
 */
export function registerModals(modals) {
    const getModalComponent = (type) => {
        return modals[type];
    };
    const createSlice = () => createModalSlice();
    const selectors = createModalSelectors();
    return { getModalComponent, selectors, createSlice };
}
